import axios from "axios";
import { SUB_CATEGORY } from "../types/subCategory.type";

const fetch = (year, category) => (dispatch) =>
  axios
    .get(`${window.API_URL}/archives?year=${year}&categories=${category}`)
    .then(({ data }) => {
      dispatch({
        type: SUB_CATEGORY.SUCCESS_FETCH,
        payload: data.data,
      });
    })
    .catch((error) => {
      console.error(error);
      dispatch({
        type: SUB_CATEGORY.FAIL_FETCH,
        payload: "Something went wrong",
      });
    });

export const subCategoryActions = {
  fetch,
};
